@let config = menuConfig();
@let title = showTitle() && (config?.title | optionalAsync);
@if (title) {
  <span class="title">{{ title }}</span>
}

@if (!showOnlyBadgeItems()) {
  @for (item of config?.items; track trackByKey($index, item)) {
    @if (showDividers() && $index > 0) {
      <div class="divider"></div>
    }

    @if (!item.collapsible) {
      <evc-menu-item
        [attr.data-testid]="item.key"
        [item]="item"
        (itemClicked)="closeMenu()"
        [attr.data-key]="item.key">
      </evc-menu-item>
    } @else {
      <evc-collapsible-panel
        [content]="item"
        [attr.data-testid]="item.key"
        [attr.data-key]="item.key">
        @for (collapsibleItem of item.collapsible; track collapsibleItem.key) {
          <evc-menu-item
            [item]="collapsibleItem"
            [attr.data-testid]="`${item.key}-${collapsibleItem.key}`"
            [selected]="isItemSelected(collapsibleItem)"
            (click)="handleCollapsibleItemClick(item, collapsibleItem)"
            [attr.data-key]="collapsibleItem.key"></evc-menu-item>
        }
      </evc-collapsible-panel>
    }
  }
}

@if (badgeMenuConfig(); as menu) {
  @if (!showOnlyMenuItems() && menu) {
    @for (badgeItem of menu; track badgeItem.id) {
      <evc-menu-item
        [badgeItem]="badgeItem"
        [aditionalText]="badgeItem.additionalText"
        [selected]="badgeItem.current ?? false"
        (organizationClicked)="handleOrganizationClick(badgeItem)"
        [attr.data-testid]="badgeItem.id"></evc-menu-item>
    }
  }
}
